module.exports = __webpack_public_path__ + "static/media/filter.d6e41b47.svg";